import React from 'react';

function SvgEchIconsUxGeothermics(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <g>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={65.585}
          x2={40.191}
          y1={94.437}
          y2={24.667}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={0.011} stopColor="#ec6608" />
          <stop offset={0.656} stopColor="#f18617" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_a)`}
          d="M28.7 41.5l3.5 3.5 13.6-13.6c.4 8.1 2.2 12.8 3.7 16.8 1.3 3.5 2.3 6.1 1.8 9.9-.3 2.5-2.3 5-4.4 7.5-2.6 3.2-5.6 6.9-5.6 11.6 0 4 .8 6.3 1.7 8.9 1 3 2.2 6.4 2.2 13.9h5c0-8.4-1.4-12.4-2.5-15.6-.8-2.3-1.4-4.1-1.4-7.2 0-2.9 2.2-5.6 4.5-8.4 2.4-3 5-6.1 5.5-10.1.6-5-.6-8.4-2.1-12.3-1.4-3.8-3-8.1-3.4-15.6L65 45l3.5-3.5-20-20-19.8 20z"
        />
        <linearGradient
          id={`${iconUuid}_b`}
          x1={56.993}
          x2={43.213}
          y1={40.234}
          y2={2.375}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={0.011} stopColor="#ec6608" />
          <stop offset={0.656} stopColor="#f18617" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_b)`}
          d="M50.1 5.7C31.9 5.7 14.4 11-.6 21.2l2.8 4.1c14.2-9.6 30.7-14.6 47.9-14.6S83.8 15.8 98 25.3l2.8-4.1C85.7 11.1 68.2 5.7 50.1 5.7z"
        />
      </g>
    </svg>
  );
}
export default SvgEchIconsUxGeothermics;
